import { useEffect, useState } from 'react';

const usePageLoadedAnimation = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const animationClasses = 'transition-opacity duration-200';
  const animatedStyles = { opacity: isPageLoaded ? 1 : 0 };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsPageLoaded(true);
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  return { animationClasses, animatedStyles };
};

export default usePageLoadedAnimation;
